import {combineReducers} from 'redux';
import markableAsReadReducer from './markable-as-read/reducer';

const reducer = combineReducers({
    markableAsRead: markableAsReadReducer,
});

export default reducer;
